<template>
  <div>
    <div class="" v-if="!isDataFetched">
      <div class="loader">
        <base-loader/>
      </div>
    </div>
    <div class="container">
        <div class="title-container">
        <div class="title-left" />
        <div class="title-right">
            <div class="">
            <div
                v-tooltip.bottom-start="{content: 'Export CSV', ...tooltipOptions}"
                class="tab"
                @click="exportCsv"
            >
                <base-material-design-icon
                icon="download"
                class="icon"
                />
            </div>
            </div>
            <div class="">
            <div
                v-tooltip.bottom-start="{content: 'Modifications', ...tooltipOptions}"
                class="tab"
                @click="$refs.select.open()"
            >
                <base-select
                id="add-tab-dropdown"
                ref="select"
                :is-hide-arrow="true"
                :options="dataModalOptions"
                align-left
                :title-style="{'padding-left': '5px', 'font-size': '12px', 'font-weight': '900'}"
                :header-style="{height: '20px !important'}"
                :prop-list-style="{cursor: 'pointer'}"
                show-top-border
                :max-height-list="500"
                :placeholder-icon="'plusCircle'"
                :border-less="true"
                :placeholder-style="{'font-size':'20px', 'color': '#011627', 'padding': '0px'}"
                @change="$modal.show($event)"
                />
            </div>
            </div>
            <div class="">
            <!-- <div class="tab" @click="$modal.show('bulk-update')"
                v-tooltip.bottom-start="{content: 'Bulk Update', ...tooltipOptions}">
                <base-material-design-icon icon="flash" class="urlc__icon" />
            </div> -->
            </div>
            <div class="">
            <div
                v-tooltip.bottom-start="{content: 'Column Editor', ...tooltipOptions}"
                class="tab"
                @click="$modal.show('column-editor')"
            >
                <base-material-design-icon
                icon="tableColumnPlusAfter"
                class="icon"
                />
            </div>
            </div>
            <base-select
            v-model="pageItemsLimit"
            :options="paginationOptions"
            align-left
            :title-style="{'padding-left': '5px'}"
            :header-style="{backgroundColor: '#ffffff'}"
            show-top-border
            shift-label-right
            :select-style="{'margin': '5px', 'height': '34px !important', width: '100px !important'}"
            :prop-list-style="{cursor: 'pointer'}"
            />
        </div>
        </div>

        <div>
        <div ref="table" />
        </div>
        <modal
        name="column-editor"
        v-bind="modalProps"
        >
        <base-tabulator-column-editor
            ref="column-editor"
            :table="tabulator"
            :hidden-columns="['edit-button']"
            @close="$modal.hide('column-editor')"
        />
        </modal>
        <modal
        name="create"
        v-bind="modalProps"
        >
        <CreateUpdateUserPopup
            ref="create-user"
            :selected-user="selectedUser"
            :opts="null"
            @apply="createOrUpdateUser($event)"
            @cancel="closeCreateModal"
        />
        </modal>
        <base-material-design-icon
        ref="iconPencil"
        style="font-size:14px;"
        icon="edit"
        />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Tabulator from 'tabulator-tables'
// import BaseTabulatorColumnEditor from '@/common/BaseTabulatorColumnEditor'
// import BaseQuickAddModal from '@/common/BaseQuickAddModal'
import baseModalProps from '@/common/BaseModalProps'
import CreateUpdateUserPopup from './CreateUpdateUserPopup'
import ToasterService from '@/services/toasterService'
import _ from 'lodash'
import BaseSortMixins from '@/common/BaseSortMixins'
import helper from '@/services/Helper'
import moment from 'moment'

const ITEMS_PER_PAGE = 100
const PAGINATION_OPTIONS = [
  {
    label: '100',
    value: 100
  },
  {
    label: '250',
    value: 250
  },
  {
    label: '500',
    value: 500
  },
  {
    label: '1000',
    value: 1000
  }
]
// table config
const DEFAULT_CONFIG = [
  {
    label: '',
    property: 'edit-button'
  },
  {
    label: 'Name',
    property: 'name'
  },
  {
    label: 'Active',
    property: 'is_active'
  },
  {
    label: 'Email',
    property: 'email'
  },
  {
    label: 'Organizations',
    property: 'agencies',
  },
  {
    label: 'Projects',
    // property: 'client_roles',
    property: 'projects',
  },
  {
    label: 'Last Login',
    property: 'last_login',
  },
]


export default {
  name: 'UserManager',
  components: { CreateUpdateUserPopup },
  mixins: [BaseSortMixins],
  data () {
    return {
      dataModalOptions: [
        {
          label: 'Create User',
          value: 'create'
        },
      ],
      tabulator: null,
      isDataFetched: false,
      isHeaderOpened: false,
      selectedUser: null,
      attachments: [],
      isDataUpdating: false,
      tableColumns: [],
      pageItemsLimit: ITEMS_PER_PAGE,
      paginationOptions: _.cloneDeep(PAGINATION_OPTIONS),
      opts: {}
    }
  },
  computed: {
    // ...mapState('linksCrud', ['links']),
    ...mapState('userManager', ['userManagerData', 'adminAgencies']),
    ...mapState(['agencies']),
    allowedAgencies () {
      return this.agencies.filter(agency => this.adminAgencies.includes(agency._id))
    },
    allowedAgencyList () {
      return this.allowedAgencies.map(agency => agency.name)
    },
    selectedIds () {
      return this.tabulator ? this.tabulator.getSelectedData().map(row => row.id) : []
    },
    modalProps () {
      const modalProps = {
        width: '60%'
      }
      return { ...baseModalProps, ...modalProps }
    },
  },
  watch: {
    userManagerData: {
      handler (newData) {
        newData = newData.map(user => ({ ...user, name: `${user.first_name} ${user.last_name}`}))
        this.tabulator && this.tabulator.replaceData(newData)
      },
      deep: true
    },
    pageItemsLimit (v) {
      this.tabulator.setPageSize(v) 
    },
    clientId: {
      handler (clientId) {
        this.loadData(clientId)
      },
      immediate: true
    },
  },
  async mounted () {
    this.isDataFetched = false
    await this.loadData(this.clientId)
    const rawIconPencilHtmlString = this.$refs.iconPencil.$el.outerHTML.toString()
    this.$refs.iconPencil.$el.parentNode.removeChild(this.$refs.iconPencil.$el)
    const columns = _.cloneDeep(DEFAULT_CONFIG).map(col => {
      col.download = true
      col.title = col.label
      col.field = col.property
      if (col.field === 'agencies') {
        col.headerFilterFunc = (headerValue, rowValue) => {
            if (!headerValue || !headerValue.length) return true
            if (headerValue.length && headerValue[0] === '-- Empty --') {
              return !rowValue.length
            }
            return rowValue.some(val => headerValue.includes(val))
        }
        col.headerFilter = 'select'
        col.headerFilterParams = {
          values: ['-- Empty --', ...this.allowedAgencyList],
          multiselect: true,
          sortValuesList: 'asc',
        }
      } else if (col.field === 'projects') {
        col.headerFilterFunc = (headerValue, rowValue) => {
            if (!headerValue || !headerValue.length) return true
            if (headerValue.length && headerValue[0] === '-- Empty --') {
              return !rowValue.length
            }
            return rowValue.some(val => headerValue.includes(val))
        }
        col.headerFilter = 'select'
        col.headerFilterParams = {
          values: ['-- Empty --', ...this.clients.map(client => client.name)],
          multiselect: true,
          sortValuesList: 'asc',
        }
      } else if (col.field === 'is_active') {
        col.formatter = 'lookup'
        col.formatterParams = { 'true': 'Yes', 'false': 'No' }
        col.headerFilter = 'select'
        col.headerFilterParams = {
          values: [{ label: 'Yes', value: true }, { label: 'No', value: false }],
          multiselect: false,
          sortValuesList: 'asc',
        }
      } else if (col.field === 'last_login') {
        col.headerFilter = null
      } else if (col.field !== 'edit-button') {
        col.headerFilter = 'input'
        col.headerFilterFunc =  (headerValue, rowValue) => {
            if (!headerValue || !headerValue.length) return true
            return rowValue.toLowerCase().includes(headerValue.toLowerCase())
        }
      }
      // const urlPageTypesColumn = tableColumnsCopy.find(col => col.field === 'url_page_type')
      // urlPageTypesColumn.headerFilterParams.values = this.pageTypes
      return col
    })
    const handleOpenEdit = (e, cell) => {
      this.openCreateModal(cell._cell.row.data._id)
    }
    const editButtonColumn = columns.find(col => col.field === 'edit-button')
    editButtonColumn.cellClick = handleOpenEdit
    editButtonColumn.formatter = () => {
      return rawIconPencilHtmlString
    }
    this.tabulator = new Tabulator(this.$refs.table, {
      data: this.userManagerData.map(user => ({ ...user, name: `${user.first_name} ${user.last_name}`})), //link data to table
      reactiveData: true, //enable data reactivity
      columns: columns, //define table columns
      autoResize: true,
      layout: 'fitColumns',
      selectable: true,
      resizableColumns: true,
      movableColumns: false,
      headerSortTristate: true,
      headerSortElement: "<i class='fas fa-caret-up'></i>",
      pagination: 'local',
      paginationSize: this.pageItemsLimit,
      persistenceID: 'link_table',
      persistenceMode: 'local',
      persistence: {
        columns: ['width', 'visible', 'frozen']
      },
    })
    this.tableColumns = this.tabulator.getColumns()
    this.isDataFetched = true
  },
  methods: {
    ...mapActions('linksCrud', ['getLinkData', 'updateLinks', 'createLinks', 'createLink', 'deleteLinkById', 'updateLink', 'getLinkOptions', 'uploadAttachment', 'getLinkAttachments', 'deleteAttachmentById', 'downloadAttachmentById']),
    ...mapActions('webProperty', ['getWebProperties']),
    ...mapActions('userManager', ['getUserManagerData', 'updateUserData']),
    exportCsv () {
      this.tabulator.download('csv', `Users_Export_${moment().format('YYYYMMDDHHmm')}.csv`)
    },
    async loadData (clientId) {
      if (!clientId) {
        return
      }

      this.isDataUpdating = true
      await this.getUserManagerData(this.clientId)
      this.isDataUpdating = false
      this.isDataFetched = true
    },
    onToggleState (isHeaderOpened) {
      this.isHeaderOpened = isHeaderOpened
    },
    async createOrUpdateUser (user) {
      this.isDataFetched = false
      await this.loadData(this.clientId)
      this.selectedUser = this.userManagerData.find(data => data._id === user._id)
    },
    closeCreateModal () {
      this.selectedUser = null
      this.$modal.hide('create')
    },
    async openCreateModal (userId) {
      if (userId) {
        this.isDataUpdating = true
        this.selectedUser = this.userManagerData.find(user => user._id === userId)
      }
      this.$modal.show('create')
    },
    async loadFilteredData () {
      this.isDataUpdating = true
      let [opts] = await Promise.all([
        this.getLinkOptions({ clientId: this.clientId }),
      ])
      if (opts) {
        this.opts = opts
        this.isDataFetched = true
      }
      this.isDataUpdating = false
    },
  },
  
}
</script>

<style scoped lang="scss">
#add-tab-dropdown {
  height: 20px !important;
  padding: 1px;
  cursor: pointer;
}

.common-table {
  background-color: $rfx-background-color;

  &__with-data {
    min-height: 350px;
    overflow-x: scroll;
  }

  &__row {
    background-color: #fff;
    border-bottom: 1px solid $rfx-light-steel;
    border-left: 1px solid $rfx-light-steel !important;
    border-right: 1px solid $rfx-light-steel !important;
  }

  &::-webkit-scrollbar {
    visibility: hidden;
  }

  & > div {
    &:last-child {
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }

  &__header {
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
    background-color: #dbdfe5 !important;

    &_scrollable {
      overflow-x: scroll;
    }
  }

  &__header-cell {
    background-color: #dbdfe5 !important;
    color: $rfx-dark-march;
    font-weight: bold;
    padding: 0;
    height: 60px;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  &__cell {
    background-color: #fff;
    color: $rfx-dark-march !important;
    height: 60px;
    padding: 0;
    display: flex;
    align-items: center;
    font-size: 12px;
    padding-left: 14px;

    &:first-child {
      padding-left: 25px;
    }

  }

}

.container {
    position: relative;
    min-height: 200vh !important;
}

.wait-columns {
background: white;
height: 300px;
border-bottom: none;
}

.keyword-header {
background-color: rgba(1, 22, 39, 0.1);
}

.cross {
font-size: 21px;
margin-left: 5px;
margin-top: -2px;
}

.title-right {
display: flex;
align-items: center;
justify-content: flex-end;
// flex: 1 1 50%;
height: 60px;

    &_multi-select {
        align-self: flex-end
    }
}

.title-left {
display: flex;
align-items: center;
}

.title-left > *:not(:last-child) {
margin-right: 30px;
}

.header-button-wrapper {
border-radius: 15px;
border: solid 1px $rfx-light-steel;
background: white;
height: 28px;
display: flex;
padding: 0 10px;
}

.copy-button {
flex: 1 1 50%;
height: 100%;
border: none;
outline: none;
color: $rfx-dark-march;
white-space: nowrap;
display: flex;
justify-content: space-between;
align-items: center;
width: 90px;
background-color: #fff;
font-size: 11px;

    &:hover {
        opacity: 0.5;
    }
}

.clear-filters {
// @extend .link__copy-button;
display: flex;
justify-content: space-between;
align-items: center;
width: auto;

}

.sortable-column {
padding-left: 14px;
}

.grid-select {
flex-basis: 100px;
}

.title-container {
padding: 14px 0;
display: flex;
align-items: center;
justify-content: space-between;
}

// .loader {
// display: flex;
// width: 100%;
// justify-content: center;
// align-items: center;
// height: calc(100vh - 530px);
// }
.loader {
    z-index: 1;
    display: flex;
    position: fixed;
    padding-top: 20vh;
    width: 100%;
    justify-content: center;
    align-items: flex-start;
    height: 100vh;
    background-color: rgba(255, 255, 255, .7);
}

.table {
position: relative;
display: flex;
flex-direction: column;
}

.update-loader {
position: absolute;
display: flex;
width: 100%;
height: 100%;
justify-content: center;
background-color: white;
top: 0;
opacity: 0.5;
z-index: 10000;
}

.update-loader-ring {
margin-top: 200px;
}

.links {
display: flex;
flex-direction: column;
align-items: center;
justify-content: space-between;
height: 100%;
}

.edit-button {
    flex: 0 0 45px;

    &.common-table__header-cell {
        flex: 0;
    }
}


.button {
width: 136px;
padding: 0 20px;
height: 60px;
border-radius: 4px;
font-size: 10px;
font-weight: 900;
text-transform: uppercase;
border: none;
outline: none;
cursor: pointer;
background-color: $rfx-medium-march;
color: #fff;
margin-left: 20px;
}

.count {
color: #b2b9be;
font-size: 14px;
font-weight: 600;
text-decoration: none;
width: 75px;
white-space: nowrap;
}

.tabs {
    display: grid;
    width: 50%;
    margin: 5px 0;
    border: 1px solid $rfx-light-steel;
    border-radius: 4px;
    height: 40px;
    flex: 15%;
    height: 34px;
    &.page-tabs {
    grid-template-columns: 1fr;
    }
}

.tab {
    font-weight: 500;
    outline: none;
    font-size: 10px;
    border: 1px solid $rfx-light-steel;
    color: $rfx-dark-march;
    margin: 0;
    cursor: pointer;
    transition: box-shadow .3s;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    text-decoration: none;
    padding: 5px;

    &:hover{
            /* box-shadow: 0 0 11px 5px rgba(33,33,33,.2); */
            background-color: rgba(1, 22, 39, 0.1);
            opacity: 1;

    }

    &_center {
            border-left: 1px solid $rfx-light-steel;
            border-right: 1px solid $rfx-light-steel;
    }

    &_disabled {
    pointer-events: none;
    cursor: default;
    }

    &_active {
        background-color: rgba(1, 22, 39, 0.1);
        opacity: 1;
    }

    &__enabled {
        color: $rfx-bright-blue
    }
}

.pagination-wrapper {
  display: flex;
  height: 60px;
  margin-top: 10px;
  justify-content: center;
  align-items: center;
  border: 1px solid $rfx-light-steel;
  border-radius: 4px;
}

.no-data-block {
  min-height: 250px;
  border-bottom: 1px solid $rfx-light-steel;
}

.common-table {
  &__header-cell {
    color: $rfx-dark-march;
    font-weight: bold;
  }
}

.edit-icon {
  cursor: pointer;
  font-size: 20px;
  justify-self: end;
  display: grid;
  color: $rfx-dark-march;
}

</style>
